module.exports = __webpack_public_path__ + "img/maximize.e04e42dc.svg";